import i18n from '@/core/i18n';

import { MembershipType } from '../types/membership-type';

const MEMBERSHIP_TYPE_I18N_KEYS: Record<MembershipType, string> = {
  [MembershipType.InHouse]: 'authenticated.team:membershipTypes.inHouse',
  [MembershipType.Partner]: 'authenticated.team:membershipTypes.partner',
  [MembershipType.Contractor]: 'authenticated.team:membershipTypes.contractor',
};

/**
 * Returns the localized label for a membership type enum value.
 */
export const getMembershipTypeLabel = (value: MembershipType): string => {
  return i18n.t(MEMBERSHIP_TYPE_I18N_KEYS[value]);
};

/**
 * Type guard: true only for a valid MembershipType enum value. Used to coerce empty
 * form values ('', null, undefined) to a default before sending to the backend, which
 * rejects a null membershipType (OPS-1472).
 */
export const isValidMembershipType = (value: unknown): value is MembershipType => {
  return (
    typeof value === 'string' && Object.values(MembershipType).includes(value as MembershipType)
  );
};
